import { create } from 'zustand'

export type Tema = 'light' | 'dark'

const CHIAVE = 'ringcoach-tema'

function leggiTemaIniziale(): Tema {
  const salvato = localStorage.getItem(CHIAVE)
  if (salvato === 'light' || salvato === 'dark') return salvato
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function applica(t: Tema): void {
  document.documentElement.setAttribute('data-tema', t)
}

interface StatoTema {
  tema: Tema
  imposta: (t: Tema) => void
  toggle: () => void
}

export const useTemaStore = create<StatoTema>((set, get) => {
  const iniziale = leggiTemaIniziale()
  applica(iniziale)
  return {
    tema: iniziale,
    imposta: (t) => {
      localStorage.setItem(CHIAVE, t)
      applica(t)
      set({ tema: t })
    },
    toggle: () => get().imposta(get().tema === 'light' ? 'dark' : 'light'),
  }
})
